// extracted by mini-css-extract-plugin
module.exports = {"bar":"ua_bar__Y4tFq","top":"ua_top__CxX3s","bottom":"ua_bottom__Q1vi2"};